import React, {Component} from 'react';

import {
    Button,
    Col,
    Collapse,
    Row
} from 'reactstrap';

import UserBubble from '../../../components/user/UserBubble';
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";

class ManageGroupRow extends Component {
    state = {
        showConfirm: false,
        disabled: false
    };

    toggleConfirm = () => {
        this.setState({showConfirm: !this.state.showConfirm});
    };

    render() {

        const {label, subLabel, disabled, isCoordinator, onRemove} = this.props;

        return (
            <div className="animated fadeIn">
                <Row>
                    <Col sm={3}>
                        <UserBubble small initials={label.charAt(0)} disabled={disabled}/>
                    </Col>
                    <Col sm={6}>
                        <div style={{margin: '.5em 0'}}>
                            <h5 style={{marginBottom: '0'}}>{label}</h5>
                            <small>{subLabel}</small>
                        </div>
                    </Col>
                    <Col sm={3}>
                        {
                            (!this.state.showConfirm && isCoordinator) && (
                                <div>
                                    <Button type="button" size="sm" onClick={this.toggleConfirm}>Remove</Button>
                                </div>
                            )
                        }
                    </Col>
                </Row>
                <Collapse isOpen={this.state.showConfirm} className="text-center">
                    <p><strong>Removing {label.split(' ')[0]} from your group will withdraw any applications you may have submitted!</strong><br/> Are you sure?</p>
                    <div className="d-flex flex-row justify-content-around" style={{marginBottom: '1em'}}>
                        <Button outline size="sm" style={{width: "10rem"}} onClick={this.toggleConfirm}>No</Button>
                        <AsyncButton task={onRemove} color="danger" size="sm" style={{width: "10rem"}}>Remove</AsyncButton>
                        {/*<BoolButtons inverse trueText="Remove" onFalse={this.toggleConfirm} onTrue={onRemove}/>*/}
                    </div>
                </Collapse>
                <hr/>
            </div>
        );
    }
}

export default ManageGroupRow;


// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/ManageGroupRow.js